import { isSelfBilled } from '../Invoice/utils';

// Core suppresses the carrier payable when shipper and carrier share an organization, so on those
// orders the contractor — not the carrier — holds the cost the first-mile columns report. Route rows
// only suppress when every order beneath them does, so a mixed route still shows its carrier total.
export const isCarrierRateSuppressed = (order) => {
    if (!order?.isRouteRow) return isSelfBilled(order);

    const routeOrders = order.routeOrders || [];

    return routeOrders.length > 0 && routeOrders.every(isSelfBilled);
};

// The route an order was most recently added to. Route rows group orders by it and order rows show it,
// so both read this one helper.
export const mostRecentRoute = (order) =>
    [...(order.routes || [])].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0]?.route;

// The first-mile payable, taken from whichever leg is actually billed.
export const fmPayableRate = (order) =>
    (isCarrierRateSuppressed(order) ? order?.contractor_rate : order?.carrier_rate) || 0;

export const fmMargin = (order) => (order?.shipper_rate || 0) - fmPayableRate(order);

// Empty selection means every loaded order — the Audit Orders button is enabled without one.
export const auditQueueOrders = (orders, selectedOrderIds) => {
    const all = orders || [];
    const selected = all.filter((order) => selectedOrderIds?.[order?.order_id]);

    return selected.length ? selected : all;
};
